import * as Steps from './TourGuideSteps';

export const GettingStarted = ({ index, currentId }, defaultProps) => {
	let currentProp = Steps.GettingStarted[index];
	if (index === 4) {
		currentProp.nextToIndex = localStorage.getItem('f-rules') ? 5 : 100;
	}
	if (index === 100) {
		currentProp = {
			index: 100,
			placement: 'left',
			message: `You can always check the rules in here.`,
			find() {
				return document.querySelector('.scroll-nav a[href="#rules"]');
			},
			nextToIndex: 5,
			backToIndex: 4,
			navigation: null,
		};
	}
	return {
		index,
		...defaultProps,
		navigation: Steps.GettingStarted.length,
		...currentProp,
	};
};

export const ControllableFields = ({ index }, defaultProps) => {
	let currentProp = Steps.ControllableFields[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.ControllableFields.length,
	};
};

export const CustomizeMessages = ({ index }, defaultProps) => {
	let currentProp = Steps.CustomizeMessages[index];
	if (index === 4) {
		currentProp.nextToIndex = localStorage.getItem('f-cmes') ? 5 : 100;
	}
	if (index === 100) {
		currentProp = {
			index: 100,
			placement: 'left',
			message: `You can always check the updating rules messages in here.`,
			find() {
				return document.querySelector(
					'.scroll-nav a[href="#updating-rules-messages"]'
				);
			},
			nextToIndex: 5,
			backToIndex: 4,
			navigation: null,
		};
	}
	return {
		index,
		...defaultProps,
		navigation: Steps.CustomizeMessages.length,
		...currentProp,
	};
};

export const SubmittingForm = ({ index }, defaultProps) => {
	let currentProp = Steps.SubmittingForm[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.SubmittingForm.length,
	};
};

export const AdvanceDesignPattern = ({ index }, defaultProps) => {
	let currentProp = Steps.AdvanceDesignPattern[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.AdvanceDesignPattern.length,
	};
};

export const AliasedRegistry = ({ index }, defaultProps) => {
	let currentProp = Steps.AliasedRegistry[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.AliasedRegistry.length,
	};
};

export const FormUpdateWithDoneTypingEvent = ({ index }, defaultProps) => {
	let currentProp = Steps.FormUpdateWithDoneTypingEvent[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.FormUpdateWithDoneTypingEvent.length,
	};
};

export const CustomizeRules = ({ index, currentId }, defaultProps) => {
	const steps = Steps.CustomizeRules[currentId] || [];
	let currentProp = steps[index];
	return {
		index,
		...defaultProps,
		navigation: steps.length,
		...currentProp,
		id: currentId in Steps.CustomizeRules ? currentId : defaultProps.id,
	};
};

export const AliasedRuleParameters = ({ index }, defaultProps) => {
	let currentProp = Steps.AliasedRuleParameters[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.AliasedRuleParameters.length,
	};
};

export const UpdatingRulesMessages = ({ index }, defaultProps) => {
	let currentProp = Steps.UpdatingRulesMessages[index];
	return {
		index,
		...defaultProps,
		...currentProp,
		navigation: Steps.UpdatingRulesMessages.length,
	};
};
